import { FontStyles } from "../utils/font-styles";
import { HeadingTag } from "../components/section-header.tsx";

export interface SectionHeaderProps {
  heading: string;
  headingAs: HeadingTag;
  subheading: string;
}

export const SectionHeader: React.FC<SectionHeaderProps> = ({ heading, headingAs: Tag, subheading }) => (
  <div className={"flex flex-col gap-3 md:gap-3.5"}>
    <Tag className={`text-north-sea font-semibold ${FontStyles.h2}`}>{heading}</Tag>
    <p className={`text-slate ${FontStyles.h6} leading-[1.5] md:leading-[1.5]`}>{subheading}</p>
  </div>
);
